import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var Stomp = require('@stomp/stompjs');
var SockJS = require('sockjs-client');

export default new Vuex.Store({
  state: {
    user: 'Kunde',
    channel: 'CHAT',
    token: '',
    dialog: '',
    error: '',
    wall: [],
    dialogs: '',
    socket: null,
    stompClient: null
  },
  getters: {
  },
  mutations: {
    updateUser (state, user) {
      state.user = user;
    },
    updateChannel (state, channel) {
      state.channel = channel;
    },
    updateToken (state, token) {
      state.token = token;
    },
    updateDialog (state, dialog) {
      state.dialog = dialog;
    },
    pushUtterance(state, utterance) {
      state.wall.push(utterance);
    },
    updateError (state, error) {
      state.error = error;
    },
    updateDialogs (state, dialogs) {
      state.dialogs = dialogs;
    }
  },
  actions: {
    async startDialog ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {

        Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/begin', {
          'channel': state.channel,
          'firstPersonName': state.user,
          'secondPersonName': 'Agent'
        })
           .then(response => {
          commit('updateDialog', response.data);
          resolve(response.data);
        }, error => {
          state.error = error;
          reject();
        })
      })
    },
    async endDialog ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId + '/end')
             .then(response => {
            commit('updateDialog', '');
            resolve(response.data);
          }, error => {
            state.error = error;
            reject();
          })

        }
      })
    },
    async getDialog ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId)
             .then(response => {
            commit('updateDialog', response.data);
            resolve(response.data);
          }, error => {
            state.error = error;
            reject();
          })

        }
      })
    },
    async getDialogs ({ commit, state } ) {
      state.error = '';
      commit('updateDialogs', '');

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dialogues')
           .then(response => {
          commit('updateDialogs', response.data);
          resolve(response.data);
        }, error => {
          state.error = error;
          reject();
        })

      })
    },
    async getDialogByID ({ commit, state }, payload ) {
      state.error = '';
      commit('updateDialog', '');
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + payload.dialogId)
           .then(response => {
          commit('updateDialog', response.data);
          resolve(response.data);
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },
    async addUtterance ({ commit, dispatch, state }, payload ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId + '/utterances', {
              'personName': state.user,
              'text': payload.text })
             .then(response => {
            commit('pushUtterance', payload);
            dispatch('getDialog');
            resolve(response.data);
          }, error => {
            state.error = error;
            reject();
          })

        }
      })
    },
    async authenticate ({ commit, dispatch, state } ) {
      return new Promise((resolve, reject) => {

        Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/authenticate', {
          "password": "admin",
          "rememberMe": true,
          "username": "admin"
        })
           .then(response => {

          commit('updateToken', response.data.id_token);

          Vue.http.interceptors.push(function(request) {
            request.headers.set('X-CSRF-TOKEN', 'TOKEN');
            request.headers.set('Authorization', 'Bearer ' +        response.data.id_token);
          });

          dispatch('getDialogs');

          state.socket = new SockJS(process.env.VUE_APP_BACKEND_WEBSOCKET_URL + "/tracker?access_token=" + state.token);
          state.stompClient = Stomp.Stomp.over(state.socket);
          state.stompClient.connect(
            {},
            frame => {
              console.log(frame);
              state.stompClient.subscribe("/updates/dialogues", tick => {
                console.log(tick);
                if( state.dialog && tick.body && tick.body.dialogueId == state.dialog.dialogId ) {
                  console.log("MY Dialog has changed");
                  dispatch('getDialog');
                }
              });
            },
            error => {
              console.log(error);
            }
          );

          resolve(response.data);
        }, error => {
          state.error = error;
          reject();
        })
      })
    },
  },
  modules: {
  }
})
